import { InjectionToken } from '@angular/core';

export type AppTranslateLoaderMode = 'http' | 'range';

export interface AppTranslateLoaderConfig {
  mode: AppTranslateLoaderMode;
  prefix: string;
  suffix: string;
  rangeChunkSizeBytes: number;
  requestTimeoutMs: number;
  maxRetries: number;
  retryDelayMs: number;
}

export const DEFAULT_APP_TRANSLATE_LOADER_CONFIG: Readonly<AppTranslateLoaderConfig> = {
  mode: 'http',
  prefix: 'i18n/',
  suffix: '.json',
  rangeChunkSizeBytes: 8192,
  requestTimeoutMs: 8000,
  maxRetries: 1,
  retryDelayMs: 250,
};

export const APP_TRANSLATE_LOADER_CONFIG = new InjectionToken<Readonly<AppTranslateLoaderConfig>>(
  'APP_TRANSLATE_LOADER_CONFIG',
  {
    factory: () => DEFAULT_APP_TRANSLATE_LOADER_CONFIG,
  },
);
